import "./PrivacyPolicy.css";

import WaCard from "@awesome.me/webawesome-pro/dist/react/card/index.js";

export default function PrivacyPolicy() {
  const rootDomain = import.meta.env.VITE_ROOT_DOMAIN;

  return (
    <section className="privacy-policy wa-stack wa-gap-s" aria-labelledby="privacy-policy-title">
      <WaCard className="privacy-policy__card wa-prose">
        <header className="wa-stack wa-gap-s">
          <h2 id="privacy-policy-title" className="wa-heading-xl">
            Privacy Policy
          </h2>
        </header>

        <p className="wa-body-m">
          Your privacy is important. This page explains what data we collect and how it is used.
        </p>

        <p>
          This website uses <strong>Plausible Analytics</strong> to understand how visitors use the
          site and to help improve it.
        </p>

        <h3 className="wa-heading-m">Analytics</h3>
        <p>
          Plausible is a privacy-friendly analytics service. It does not use cookies and does not
          collect personal data. All data is collected in an anonymous, aggregated form.
        </p>

        <p>We collect high-level usage information such as:</p>
        <ul>
          <li>Page views</li>
          <li>Referring pages</li>
          <li>Browser and device type</li>
          <li>Operating system</li>
          <li>Approximate country</li>
        </ul>

        <p>
          We also track anonymous interaction events (such as feature usage, button clicks, or error
          states) to understand how the site is used. These events do not contain personal
          information and cannot be used to identify individual users.
        </p>

        <h3 className="wa-heading-m">Server logs</h3>
        <p>
          We may temporarily process technical information in server logs for the purpose of
          debugging, security, and service reliability. This may include request metadata and error
          information.
        </p>
        <p>
          Where location-like values (such as latitude and longitude) appear in logs, we apply
          automatic masking to help prevent sensitive data from being visible in log output.
        </p>
        <p>
          This data is not used for tracking or profiling, is not shared with third parties, and is
          retained only for as long as necessary for operational purposes. Logs are automatically
          deleted after a short retention period.
        </p>

        <h3 className="wa-heading-m">What we do not collect</h3>
        <ul>
          <li>IP addresses</li>
          <li>User IDs</li>
          <li>Cookies</li>
          <li>Any personally identifiable information</li>
        </ul>

        <h3 className="wa-heading-m">Legal basis</h3>
        <p>
          Analytics data is processed under <strong>legitimate interest</strong> for the purpose of
          maintaining and improving the website, in accordance with applicable data protection laws
          (including GDPR where relevant).
        </p>

        <h3 className="wa-heading-m">Third parties</h3>
        <p>
          Analytics data is processed by Plausible Analytics. Plausible does not track users across
          websites and does not sell or share personal data.
        </p>

        <h3 className="wa-heading-m">Contact</h3>
        <p>
          If you have any questions about this privacy policy, contact us at{" "}
          <a href={`mailto:privacy@${rootDomain}`} className="wa-link">
            privacy@{rootDomain}
          </a>
          .
        </p>
      </WaCard>
    </section>
  );
}
